var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cms-client-rules-icon",style:(_vm.positionStyle),on:{"click":_vm.clickHandle}},[_c('img',{attrs:{"src":_vm.picHost+_vm.rulesImg}})])}
var staticRenderFns = []

export { render, staticRenderFns }